function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  viewBox: "0 0 41 40"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(8 8)"
}, React.createElement("circle", {
  cx: "4.5",
  cy: "15",
  r: "4"
}), React.createElement("circle", {
  cx: "19.5",
  cy: "15",
  r: "4"
}), React.createElement("path", {
  d: "M11 15.001l5.684-7.646L9 10l-4.5 5H11L7.75 7"
}), React.createElement("path", {
  d: "M19.5 15l-3.307-8.977a.5.5 0 01.348-.658L18 5M6.5 7h3"
}))));